import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"

const TemplateFindOutMore: FC = () => (
  <Body small color="white" textAlign="center">
    <FormattedMessage id="platform.homepage.companyNews.template.findOutMore" />
  </Body>
)

export default TemplateFindOutMore
